import * as AccountDetailsActionTypes from '../actionTypes/AccountDetailsActionTypes';

/* istanbul ignore next */
export const getProfile = (headers) => ({
    type: AccountDetailsActionTypes.PROFILE,
    headers,
});

export const getLightProfile = () => ({
    type: AccountDetailsActionTypes.LIGHT_PROFILE,
});

export const updateProfile = (accountId, requestFrom) => ({
    type: AccountDetailsActionTypes.UPDATE_PROFILE,
    payload: accountId,
    requestFrom,
});

export const cleanProfileRequest = () => ({
    type: AccountDetailsActionTypes.CLEAN_PROFILE_REQUEST,
});

export const submitPromotionalDetails = (payload) => ({
    type: AccountDetailsActionTypes.SUBMIT_PROMOTIONAL_DETAILS,
    payload,
});

export const closePromotionalSuccessModal = () => ({
    type: AccountDetailsActionTypes.CLOSE_PROMOTIONAL_DETAILS_MODAL,
});
